var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "static-report-ribbon" }, [
    !_vm.isDataLoaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c("div", { staticClass: "flex-container pl-2 pr-2" }, [
          _c("div", { staticClass: "flex-col flex-10" }, [
            _c("div", { staticClass: "flex-row" }, [
              _c("div", { staticClass: "flex-col" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("selectAsset")))]),
                _c(
                  "div",
                  { staticClass: "flex-row flex-1" },
                  [
                    _c("static-report-dropdown", {
                      staticClass: "select",
                      staticStyle: { width: "auto" },
                      attrs: {
                        options: _vm.assetAndCalculationDate,
                        default: _vm.assetselection,
                      },
                      on: { input: _vm.onSelectAsset },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "mr-2" }),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }